import { render } from "./SplashLoader.vue?vue&type=template&id=67b22fd0&scoped=true"
const script = {}

import "./SplashLoader.vue?vue&type=style&index=0&id=67b22fd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b22fd0"]])

export default __exports__